import { useQuery } from '@tanstack/react-query';

import { SupplierDto } from '@app/integ-apigee-interfaces';
import { Axios } from '@app/web-components';

const SUPPLIER_ALL_QUERY_KEY = 'SUPPLIER_ALL_QUERY_KEY';

const SupplierKeys = {
  all: [SUPPLIER_ALL_QUERY_KEY] as const,
  lists: () => [...SupplierKeys.all, 'list'] as const,
  list: (filters: object) => [...SupplierKeys.lists(), filters] as const,
};

export const useSuppliersQuery = (params: { count?: number; name?: string; orderby?: string; status?: string }) => {
  const axios = Axios.useAxiosApi();
  params.name = encodeURIComponent(params.name ?? '');
  return useQuery<SupplierDto[]>({
    queryKey: SupplierKeys.list(params),
    queryFn: async () => {
      const { data } = await axios.get('/suppliers', { params });
      return data;
    },
  });
};
